import { render } from "./GenericPage.vue?vue&type=template&id=5517c520"
import script from "./GenericPage.vue?vue&type=script&lang=ts"
export * from "./GenericPage.vue?vue&type=script&lang=ts"
script.render = render

export default script